/**
 * 아래 값들은 박스가 DOM에 올라가기 전 "첫 프레임 추정치"일 뿐이다.
 * 실제 배치는 MessageBoxLayer에서 렌더된 박스를 실측해 화면 경계로 클램프한다.
 */

export const MESSAGE_BOX_MAX_WIDTH = {
  default: 360,
  sm: 280,
} as const;

/**
 * 가용 폭이 좁아도 이 아래로는 줄이지 않는다.
 * 폭에 맞춰 무한정 좁히면 박스가 좁고 길쭉해져 오히려 읽기 어려워진다.
 */
export const MESSAGE_BOX_MIN_WIDTH = 200;

type MessageBoxSize = keyof typeof MESSAGE_BOX_MAX_WIDTH;

/* sm 변형은 padding(32→20)과 폰트(16→14)가 줄어든 만큼 작게 잡는다 */
const SIZE_RATIO: Record<MessageBoxSize, number> = {
  default: 1,
  sm: 0.78,
};

export const getBoxWidth = (
  nowMessageBoxTextLength: number,
  size: MessageBoxSize = 'default',
) => {
  const ratio = SIZE_RATIO[size];

  if (nowMessageBoxTextLength > 21) {
    return MESSAGE_BOX_MAX_WIDTH[size];
  } else if (nowMessageBoxTextLength >= 15) {
    return (120 + nowMessageBoxTextLength * 10) * ratio;
  } else if (nowMessageBoxTextLength >= 10) {
    return (120 + nowMessageBoxTextLength * 8) * ratio;
  } else if (nowMessageBoxTextLength >= 5) {
    return (60 + 60 + nowMessageBoxTextLength * 4) * ratio;
  } else {
    return (60 + 50) * ratio;
  }
};

export const getDivideLineIncludeBoxWidth = (
  text: string,
  size: MessageBoxSize = 'default',
) => {
  const lines = text.split('\n');
  const longestLine = lines.reduce((a, b) => (a.length > b.length ? a : b));
  return getBoxWidth(longestLine.length, size);
};

export const getBoxHeight = (
  nowMessageBoxTextLength: number,
  size: MessageBoxSize = 'default',
) => {
  const MIN_TEXT_LENGTH = 21;
  const TEXT_LENGTH_STANDARD = 20;
  const BASIC_BOX_HEIGHT = 160;
  const ratio = SIZE_RATIO[size];

  if (nowMessageBoxTextLength > 0 && nowMessageBoxTextLength <= 21) {
    return BASIC_BOX_HEIGHT * ratio;
  } else if (nowMessageBoxTextLength > 210) {
    return 360 * ratio;
  } else {
    return (
      (Math.floor(nowMessageBoxTextLength / MIN_TEXT_LENGTH) *
        TEXT_LENGTH_STANDARD +
        BASIC_BOX_HEIGHT) *
      ratio
    );
  }
};

export const getDivideLineIncludeBoxHeight = (
  text: string,
  size: MessageBoxSize = 'default',
) => {
  const lines = text.split('\n');
  const longestLine = lines.reduce((a, b) => (a.length > b.length ? a : b));
  const ratio = SIZE_RATIO[size];

  if (longestLine.length > 21) {
    return (
      getBoxHeight(longestLine.length, size) + (lines.length - 1) * 20 * ratio
    );
  } else {
    return (160 + lines.length * 20) * ratio;
  }
};
